app.service('cartRetrieve', function (modal, loading, log, front, simpleToastr, broker) {

	function setAction(action, cart, callback) {
		loading.start();
		logAction(action);
		$.ajax({
			url: '/merge-carts.ltr',
			type: 'POST',
			data: {
				action: action,
				previousCartCookie: cart
			},
			success: function (json) {
				if (json.status === 'SUCCESS') {
					modal.close();
					if (callback) {
						callback();
					} else {
						loading.redirect('/cart.bhtml');
					}
				} else {
					modal.alert('Błąd łączenia koszyków. Spróbuj ponownie');
				}
			},
			error: function () {
				modal.alert('Błąd w komunikacji łączenia koszyków. Spróbuj ponownie');
			}
		})
	}
	function logAction(action){
		log.event({ id: 'laczenie-koszykow', f03: action });
		UA.push({
			event: 'laczenie-koszykow',
			action: action
		});
	}
	let isOneInit = false;
	
	function init(){
		if(!isOneInit){
			isOneInit = true;
			$('body').on('click', '.js-cart-retrive-action', function () {
				let $this = $(this);
				let action = $this.data('action');
				let cart = $this.data('cart');
				let page = front.page();
				if(action == 'MERGE'){
					simpleToastr.afterReloadMessage(`<h2>Produkty zostały dodane do koszyka</h2>`);
				} else if(action == 'OVERRIDE_LAST'){
					simpleToastr.afterReloadMessage(`<h2>Wcześniejszy koszyk został usunięty</h2>`);
				} else if(action == 'OVERRIDE_CURRENT'){
					simpleToastr.afterReloadMessage(`<h2>Koszyk został przywrócony</h2>`);
				}
				if(page == 'basket'){
					setAction(action, cart, function () {
						broker.trigger('REFRESH_BASKET_VIEW');
					});
				}else if(page.indexOf('delivery') > 0){
					setAction(action, cart);
				}
			}).on('click', '.js-cart-retrieve-more', function () {
				modal.open('cart-retrieve');
				logAction('open-details');
			});
		}
		if($('#cart-retrieve').length){
			logAction('wyświetlenie - ścieżka');
		}
	}

	return {
		init
	};
});